import type { CSSProperties, KeyboardEvent, ReactNode } from 'react';

interface PropsTarjeta {
  children: ReactNode;
  relleno?: number;
  /** Se levanta al pasar el mouse. Las tarjetas con alPulsar lo hacen siempre. */
  resaltable?: boolean;
  alPulsar?: () => void;
  etiqueta?: string;
  className?: string;
  style?: CSSProperties;
}

export function Tarjeta({
  children, relleno = 24, resaltable = false, alPulsar, etiqueta, className, style,
}: PropsTarjeta) {
  const clases = [
    'tarjeta',
    (resaltable || alPulsar) && 'tarjeta--resaltable',
    alPulsar && 'tarjeta--pulsable',
    className,
  ].filter(Boolean).join(' ');

  // Una tarjeta entera clickeable no puede ser un <button> (adentro lleva bloques),
  // así que se le da el rol y el manejo de teclado a mano.
  const interaccion = alPulsar && {
    role: 'button',
    tabIndex: 0,
    'aria-label': etiqueta,
    onClick: alPulsar,
    onKeyDown: (e: KeyboardEvent<HTMLDivElement>) => {
      if (e.target !== e.currentTarget) return;
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        alPulsar();
      }
    },
  };

  return (
    <div className={clases} style={{ padding: relleno, ...style }} {...interaccion}>
      {children}
    </div>
  );
}
